export class Field {
    public label: string;
    public name: string;
    public type: string;
    public required: boolean;
    public value: any;
    public hidden: boolean;
    public entries: Array<any>;//{Key, Value}
    public class: string;

    constructor(label: string, name: string, type: string, required: boolean) {
        this.label = label;
        this.name = name;
        this.type = type;
        this.required = required;
    }
}



// WEBPACK FOOTER //
// ./src/models/crud/Field.ts